export const markets = [
	{
		code: 'AT',
		fullName: 'AT - Austria',
		phoneNumberCode: '+43',
		phoneLocale: 'de-AT',
	},
	{
		code: 'AU',
		fullName: 'AU - Australia',
		phoneNumberCode: '+61',
		phoneLocale: 'en-AU',
	},
	{
		code: 'BE',
		fullName: 'BE - Belgium',
		phoneNumberCode: '+32',
		phoneLocale: 'fr-BE',
	},
	{
		code: 'CA',
		fullName: 'CA - Canada',
		phoneNumberCode: '+1',
		phoneLocale: 'en-CA',
	},
	{
		code: 'CH',
		fullName: 'CH - Switzerland',
		phoneNumberCode: '+41',
		phoneLocale: 'de-CH',
	},
	{
		code: 'DE',
		fullName: 'DE - Germany',
		phoneNumberCode: '+49',
		phoneLocale: 'de-DE',
	},
	{
		code: 'DK',
		fullName: 'DK - Denmark',
		phoneNumberCode: '+45',
		phoneLocale: 'da-DK',
	},
	{
		code: 'EE',
		fullName: 'EE - Estonia',
		phoneNumberCode: '+372',
		phoneLocale: 'et-EE',
	},
	{
		code: 'FI',
		fullName: 'FI - Finland',
		phoneNumberCode: '+358',
		phoneLocale: 'fi-FI',
	},
	{
		code: 'FO',
		fullName: 'FO - Faroe Islands',
		phoneNumberCode: '+298',
		phoneLocale: 'fo-FO',
	},
	{
		code: 'FR',
		fullName: 'FR - France',
		phoneNumberCode: '+33',
		phoneLocale: 'fr-FR',
	},
	{
		code: 'GL',
		fullName: 'GL - Greenland',
		phoneNumberCode: '+299',
		phoneLocale: 'kl-GL',
	},
	{
		code: 'IE',
		fullName: 'IE - Ireland',
		phoneNumberCode: '+353',
		phoneLocale: 'en-IE',
	},
	{
		code: 'LT',
		fullName: 'LT - Lithuania',
		phoneNumberCode: '+370',
		phoneLocale: 'lt-LT',
	},
	{
		code: 'LU',
		fullName: 'LU - Luxembourg',
		phoneNumberCode: '+352',
		phoneLocale: 'de-LU',
	},
	{
		code: 'LV',
		fullName: 'LV - Latvia',
		phoneNumberCode: '+371',
		phoneLocale: 'lv-LV',
	},
	{
		code: 'NL',
		fullName: 'NL - Netherlands',
		phoneNumberCode: '+31',
		phoneLocale: 'nl-NL',
	},
	{
		code: 'NO',
		fullName: 'NO - Norway',
		phoneNumberCode: '+47',
		phoneLocale: 'nb-NO',
	},
	{
		code: 'NZ',
		fullName: 'NZ - New Zealand',
		phoneNumberCode: '+64',
		phoneLocale: 'en-NZ',
	},
	{
		code: 'SE',
		fullName: 'SE - Sweden',
		phoneNumberCode: '+46',
		phoneLocale: 'sv-SE',
	},
	{
		code: 'UK',
		fullName: 'UK - United Kingdom',
		phoneNumberCode: '+44',
		phoneLocale: 'en-GB',
	},
	{
		code: 'US',
		fullName: 'US - United States',
		phoneNumberCode: '+1',
		phoneLocale: 'en-US',
	},
]